module.exports = __webpack_public_path__ + "static/media/WhatWeDo_Courses.4f5407b4.jpg";